import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react';

import ClickableDiv from '../../shared_components/ClickableDiv/ClickableDiv';
import { InputControl } from '../index';

import styles from './SharesCalculator.module.scss';

type Props = {
  quantity: number;
  setQuantity: Dispatch<SetStateAction<number>>;
  disabled?: boolean;
  maxQuantity?: number;
  clearNumberOfSharesError?: Dispatch<SetStateAction<string>>;
}

const SharesCalculator = ({
  quantity, setQuantity, clearNumberOfSharesError, disabled, maxQuantity,
}: Props) => {
  const [inputValue, setInputValue] = useState<string>(quantity.toString());

  useEffect(() => {
    if (parseInt(inputValue, 10) !== quantity && !isNaN(quantity)) {
      if (quantity.toString() !== inputValue) {
        setInputValue(quantity.toString());
      }
    }
    // eslint-disable-next-line
  }, [quantity]);

  const reduceValue = () => {
    clearNumberOfSharesError && clearNumberOfSharesError('');
    if (typeof quantity === 'number' && quantity > 0) {
      setQuantity((currentQuantity: number) => currentQuantity - 1);
    }
  };

  const addValue = () => {
    clearNumberOfSharesError && clearNumberOfSharesError('');
    if (typeof quantity !== 'number' || !inputValue) {
      setQuantity(1);
      setInputValue('1');
      return;
    }
    if (maxQuantity) {
      if (quantity < maxQuantity) {
        setQuantity((currentQuantity: number) => currentQuantity + 1);
      }
    } else {
      setQuantity((currentQuantity: number) => currentQuantity + 1);
    }
  };

  return (
    <>
      <div className={styles.calculationContainer}>
        <ClickableDiv className={styles.calculationButton} onClick={reduceValue}>
          <span className={styles.minusAndPlus}>-</span>
        </ClickableDiv>
        <div className={styles.resultFieldWrapper}>
          <InputControl
            className={styles.resultFieldInput}
            type="number"
            min={0}
            placeholder=""
            withMinimumValue
            name="quantity"
            value={inputValue}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              (maxQuantity && Number(event.target.value) > maxQuantity)
                ? setQuantity(maxQuantity) : setQuantity(parseInt(event.target.value, 10));
              clearNumberOfSharesError && clearNumberOfSharesError('');
            }}
          />
        </div>
        <ClickableDiv
          className={[styles.calculationButton, styles.calculationButtonRight].join(' ')}
          onClick={addValue}
        >
          <span className={styles.minusAndPlus}>+</span>
        </ClickableDiv>
      </div>
    </>
  );
};

export default SharesCalculator;
